<template>
  <tiles-page
    title="Администрирование"
    :link-groups="linksGroups"
    sm="12"
    md="6"
    xl="4"
  />
</template>

<script>
  import TilesPage from '@/components/ui/TilesPage.vue'
  import RouteName from '@/models/enums/RouteName'
  import CRMPermission from '@/models/enums/permissions/CRMPermission'

  export default {
    name: 'AdministrationPage',
    components: { TilesPage },
    data () {
      return {
        linksGroups: [
          {
            title: 'Биллинг',
            permissions: [CRMPermission.ViewAdministrationBilling],
            links: [
              {
                icon: 'file-invoice-dollar',
                cols: 12,
                routeName: RouteName.AdministrationPaymentAccounts,
                title: 'Платёжные аккаунты',
              },
              {
                icon: 'landmark',
                cols: 6,
                routeName: RouteName.AdministrationFaktLegalEntities,
                title: 'Юрлица FAKT',
              },
              {
                icon: 'crown',
                cols: 6,
                routeName: RouteName.AdministrationTariffs,
                title: 'Тарифы',
                permissions: [CRMPermission.ViewAdministrationTariffs],
              },
            ],
          },
          {
            title: 'Филиалы',
            permissions: [CRMPermission.ViewAdministrationFilials],
            links: [
              {
                icon: 'store',
                cols: 12,
                routeName: RouteName.AdministrationFilialConnection,
                title: 'Подключение филиалов',
              },
            ],
          },
        ],
      }
    },
  }
</script>
